import { Outlet } from "react-router-dom";
import Dashboard from "./dashboard-component";

const Layout = () => {
  return (
    <>
      {/* <Dashboard /> */}
      {/* Outlet 會自動在 Layout 下的其他 Route 標籤內自動轉換 */}
      <Outlet />
    </>
  );
};

export default Layout;
